import { RobotIcon } from "../../icons/RobotIcon";
import { Button, IconButton, ListSubheader, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useMenu } from "../../hooks/useMenu";

export type InstructorCalendarView = "timeGridDay" | "timeGridWeek" | "dayGridMonth";

export const instructorCalendarViewLabels: Record<InstructorCalendarView, string> = {
  timeGridDay: "Tag",
  timeGridWeek: "Woche",
  dayGridMonth: "Monat",
};

const calendarViewChoices = [
  { id: "timeGridDay", name: instructorCalendarViewLabels.timeGridDay },
  { id: "timeGridWeek", name: instructorCalendarViewLabels.timeGridWeek },
  { id: "dayGridMonth", name: instructorCalendarViewLabels.dayGridMonth },
] as const satisfies Array<{ id: InstructorCalendarView; name: string }>;

export function isInstructorCalendarView(view: string | undefined): view is InstructorCalendarView {
  return view === "timeGridDay" || view === "timeGridWeek" || view === "dayGridMonth";
}

export function InstructorCalendarHeaderMenuButton(props: {
  activeCalendarView?: string;
  changeCalendarView?: (view: InstructorCalendarView) => void;
  setShowRecommednationFilters: (state: boolean) => void;
}) {
  const { activeCalendarView, changeCalendarView, setShowRecommednationFilters } = props;
  const { anchorEl, open, openMenu, closeMenu } = useMenu();

  return (
    <div>
      <IconButton size="small" onClick={openMenu} aria-label="Fahrlehrerkalender-Menü öffnen">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={closeMenu}>
        <MenuItem onClick={closeMenu}>
          <Button
            variant="text"
            startIcon={<RobotIcon />}
            onClick={() => {
              setShowRecommednationFilters(true);
            }}
          >
            Zeige Terminvorschläge
          </Button>
        </MenuItem>
        {changeCalendarView && [
          <ListSubheader key="view-subheader">Ansicht</ListSubheader>,
          ...calendarViewChoices.map((choice) => (
            <MenuItem
              key={choice.id}
              selected={activeCalendarView === choice.id}
              onClick={() => {
                closeMenu();
                changeCalendarView(choice.id);
              }}
            >
              {choice.name}
            </MenuItem>
          )),
        ]}
      </Menu>
    </div>
  );
}
